<template>
  <div class="card shadow p-3">
    <div
      class="card-header border-0 bg-transparent"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0 bg-transparent">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <b-button
            size="sm"
            variant="outline-primary"
             @click="$refs.create.showModal({data:null, company: $route.params.id})"
            >{{ $t("add") }}</b-button
          >
        </div>
      </div>
    </div>
    <b-row>
      <b-col md="2">
        <b-form-select
        v-if="!Array.isArray(tableData.data) || tableData.data.length === 0 ? false : true"
          v-model="perPage"
          :options="[5, 10, 20, 100]"
          @input="changePerPage"
          size="sm"
          class="mt-2"
        ></b-form-select>
      </b-col>
      <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
        <b-form-group>
          <b-input-group>
            <b-form-input
            v-if="!Array.isArray(tableData.data) || tableData.data.length === 0 ? false : true"
              class="form-control-sm"
              v-model="searchData"
              type="search"
              :placeholder="$t('search')"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="!Array.isArray(tableData.data) || tableData.data.length === 0 ? true : false"
        >
         <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <span class="h2 text-danger">{{ $t('fail') }}</span>
                    </div>
                  </template>
          <template v-slot:cell(image)="data">
            <b-avatar  variant="primary" :src="imageData(data.item.picture)" size="3rem" rounded></b-avatar>
            <!-- <a
              href="#"
              class="avatar rounded-circle mr-3"
            >
              <img
                alt="Image placeholder"
                :src="imageData(data.item.picture)"
              />
            </a> -->
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              variant="warning"
              size="sm"
               @click="$refs.create.showModal({data: data.item, company: $route.params.id})"
              v-b-tooltip.hover
              :title="$t('edit')"
              ><i class="far fa-edit"></i
            ></b-button>
            <b-button
              v-b-tooltip.hover
              :title="$t('delete')"
              variant="danger"
              size="sm"
              @click="deleteCategory(data.item.id)"
              ><i class="far fa-trash-alt"></i
            ></b-button>
          </template>
        </b-table>
        <b-pagination
         v-if="!Array.isArray(tableData.data) || tableData.data.length === 0 ? false : true"
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
    <!-- <modal-create
      :modal.sync="modalActive"
      @close="closeModal"
      :data-category="dataCategory"
    ></modal-create> -->
    <modal-create ref="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ModalCreate from "../Categories/modalCreate";
import {myRendeImage} from "@/directives/render-Image"
import _ from "lodash";
export default {
  name: "categories-table",
  mixins: [myRendeImage],
  components: {
    ModalCreate
  },
  props: {
    type: {
      type: String
    },
    title: String
  },
  async created() {
    await this.getCategories({
      currentPage: this.currentPage,
      perPage: this.perPage,
      company_id: this.$route.params.id
    });
    this.debouncedGetAnswer = _.debounce(this.search, 500);
  },
  watch: {
    searchData: function(newQuestion, oldQuestion) {
      this.debouncedGetAnswer();
    }
  },
  data() {
    return {
      modalActive: false,
      dataCategory: {},
      perPage: 5,
      currentPage: 1,
      searchData: ""
    };
  },
  methods: {
    async openModal(change) {
      this.$bvModal.show("bv-modal-inventory");
    },
    async closeModal(change) {
      this.modalActive = change.close;
      if (change.refresh) await this.changePerPage();
    },
    async modalEdit(item) {
      this.dataCategory = item;
      this.modalActive = true;
    },
    ...mapActions({
      getCategory: "category/getCategory",
      getCategories: "category/get",
      delCompany: "category/delete"
    }),
    async search() {
      await this.getCategories({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
        company_id: this.$route.params.id
      });
    },
    async changePage(value) {
      await this.getCategories({
        currentPage: value ? value : 1,
        perPage: this.perPage,
        company_id: this.$route.params.id
      });
    },
    async changePerPage() {
      await this.getCategories({
        currentPage: this.currentPage,
        perPage: this.perPage,
        company_id: this.$route.params.id
      });
    },
    async deleteCategory(id) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t("question_delete_category"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not")
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            const res = await this.delCompany(id);
            this.$toast.success(res.message, {
              position: "top-right"
            });
            await this.changePerPage();
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      tableData: "category/categories",
    }),
    columns() {
      return [
        { label: "", key: "image", class: "text-center" },
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t('description'), key: "description", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-right" }
      ];
    },
  }
};
</script>